import {Form, InputNumber, Modal,  App,  Row, Col, DatePicker, Space   } from 'antd'
import { ASSETS_APPLICATION_BASE } from '../../config/api'
import React, { useEffect,useState } from 'react'
import classes from './expense.module.css' 
import { useFeiyongUpdateSaveMutation, useFYtijiaoMutation, useFeiyongUpdateQuery } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';
import ClientBankSelect from '../../system/client/ClientBankSelect';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import Icon from '../../cpn/Icon';
// import ExpenseWithdraw from './ExpenseWithdraw';        
import DocumentRule from '../../cpn/DocumentRule';  
import Asterisk from '../../cpn/Asterisk';
import ExpenseDel from './ExpenseDel';
import ArapTypeSelect from '../../cpn/ArapTypeSelect';
import StateTag from '../../cpn/StateTag';
import AccountCheck from '../../system/account/AccountCheck';
function ExpenseEdit(props) {
    // 若 props 中企业 id/名 为空或 0，则从本地存储读取
    const qy_id = (props.qy_id === 0 || props.qy_id === null || props.qy_id === undefined || props.qy_id === '')
        ? (JSON.parse(localStorage.getItem('jtg-caiwu_qy_id')) ?? props.qy_id)
        : props.qy_id;
    const qy_name = (props.qy_name === '' || props.qy_name === undefined)
        ? (JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')) ?? props.qy_name)
        : props.qy_name;
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'fy_price':'',   
        'fy_uid':'',
        'fy_uname':'',
        'fy_content':'',
        'fy_bzd_id':'',
        'fy_qy_id':'',
        'fy_qy_name':'',
        'fy_kh_id':'',
        'fy_kh_name':'',
        'fy_type_id':'',
        'fy_type_name':'',
        'fy_amount':'',
        'fy_bzd_xuhao':'',
        'fy_bzd_name':'',
        'fy_date':'',
        'fy_bzd_date_end':'',
        'fy_num':'',
        'fy_name':'',
        'fy_bzd_date':'',
        'fy_khyhzh_id':'',
        'fy_khyhzh_name':'',
        'fy_image_name':'',
        'fy_image_file':'',
        'fy_bm_id':'',
        'fy_bm_name':'',
        'fy_state':'',
        'fy_ctime':'',
        'fy_state_time':'',
        'fy_zflx':'',
        'fy_qyyhzh_id':'',
        'fy_qyyhzh_name':'',
        'fy_qyyhzh_date':'',
    })
    const {data, isSuccess} = useFeiyongUpdateQuery({fy_id:props.fy_id},{skip:!open});
    const [form] = Form.useForm();
    const [updateSave] = useFeiyongUpdateSaveMutation();  
    const [defaultFileList, setDefaultFileList] = useState([]);
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'fy_price': data.Result.fy_price,   
                'fy_uid': data.Result.fy_uid,
                'fy_uname': data.Result.fy_uname,
                'fy_content': data.Result.fy_content,
                'fy_bzd_id': data.Result.fy_bzd_id,
                'fy_qy_id': data.Result.fy_qy_id,
                'fy_qy_name': data.Result.fy_qy_name,
                'fy_kh_id': data.Result.fy_kh_id,
                'fy_kh_name': data.Result.fy_kh_name,
                'fy_type_id': data.Result.fy_type_id,
                'fy_type_name': data.Result.fy_type_name,
                'fy_amount': data.Result.fy_amount,
                'fy_bzd_xuhao': data.Result.fy_bzd_xuhao,
                'fy_bzd_name': data.Result.fy_bzd_name,
                'fy_date': data.Result.fy_date,
                'fy_bzd_date_end': data.Result.fy_bzd_date_end,
                'fy_num': data.Result.fy_num,
                'fy_name': data.Result.fy_name,
                'fy_bzd_date': data.Result.fy_bzd_date,
                'fy_khyhzh_id': data.Result.fy_khyhzh_id,
                'fy_khyhzh_name': data.Result.fy_khyhzh_name,
                'fy_image_name': data.Result.fy_image_name?data.Result.fy_image_name:'',
                'fy_image_file': data.Result.fy_image_file?data.Result.fy_image_file:'',
                'fy_bm_id': data.Result.fy_bm_id,
                'fy_bm_name': data.Result.fy_bm_name,
                'fy_state': data.Result.fy_state,
                'fy_ctime': data.Result.fy_ctime,
                'fy_state_time': data.Result.fy_state_time,
                'fy_zflx': data.Result.fy_zflx,
                'fy_qyyhzh_id': data.Result.fy_qyyhzh_id,
                'fy_qyyhzh_name': data.Result.fy_qyyhzh_name,
                'fy_qyyhzh_date': data.Result.fy_qyyhzh_date,
            });
            setDefaultFileList(Array.isArray(data.Result.fy_image_name) ? data.Result.fy_image_name.filter(Boolean) : []);
            const imageNameArray = Array.isArray(data.Result.fy_image_name) 
            ? data.Result.fy_image_name.filter(Boolean)
            : (data.Result.fy_image_name ? [data.Result.fy_image_name] : []);
            const imageFileArray = Array.isArray(data.Result.fy_image_file)
                ? data.Result.fy_image_file.filter(Boolean)
                : (data.Result.fy_image_file ? [data.Result.fy_image_file] : []);

            const fileListForForm = imageNameArray.map((serverFileName, i) => {
                // 确保 URL 是完整路径
                // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                let fullUrl = serverFileName;
                if (serverFileName.startsWith('http://')) {
                    // 完整 URL，直接使用
                    fullUrl = serverFileName;
                } else if (serverFileName.startsWith('/')) {
                    // 已经是相对路径，检查是否需要添加 /api 前缀
                    if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                        fullUrl = `/api${serverFileName}`;
                    } else {
                        fullUrl = serverFileName;
                    }
                } else {
                    // 只是文件名，使用 /api/assets/images/application/ 路径
                    fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                }
                
                // 获取显示名称
                const displayName = imageFileArray[i] || undefined;
                
                return {
                    uid: `file-${i}-${serverFileName}`,
                    name: displayName || serverFileName || `文件${i + 1}`,
                    status: 'done',
                    url: fullUrl,
                    response: {
                        Result: serverFileName // 保存服务器文件名用于提交
                    }
                };
            });       
            form.setFieldsValue({
                    'fy_price': data.Result.fy_price,  
                    'fy_uid': data.Result.fy_uid,
                    'fy_uname': data.Result.fy_uname,
                    'fy_content': data.Result.fy_content,
                    'fy_bzd_id': data.Result.fy_bzd_id,
                    'fy_bzd_name': data.Result.fy_bzd_name,
                    'fy_kh_id': data.Result.fy_kh_id,
                    'fy_kh_name': data.Result.fy_kh_name,
                    'fy_name': data.Result.fy_name,
                    'fy_type_name': data.Result.fy_type_name,
                    'fy_num': data.Result.fy_num,
                    'fy_bm_name': data.Result.fy_bm_name,
                    'fy_date': dayjs(data.Result.fy_date),
                    'fy_khyhzh_name': data.Result.fy_khyhzh_name,
                    'fy_amount': data.Result.fy_amount,
                    'fy_image_name': imageNameArray,
                    'fy_image_file': fileListForForm,
                    'fy_zflx': data.Result.fy_zflx,
            })

        }
        
        
        
        
    }, [data, isSuccess,form])    

   
    //提交费用单
    const [tijiao] = useFYtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.fy_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #3366cc',borderLeft:'3px solid #3366cc'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#3366cc',borderTop:'3px solid #3366cc'}}>费用单</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #3366cc',borderRight:'3px solid #3366cc'}}></Col>
                        {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #3366cc',color:'#3366cc'}}>团队名称</Col>
                        <Col span={6}  className={classes.col_top_input} style={props.fy_bzd_name ? {} : {padding: '15px'}}>
                            {info.fy_bzd_name}
                        </Col>  
                        <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {info.fy_type_name}
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #3366cc'}}>
                            {info.fy_num}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 日期</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           <Form.Item name='fy_date' noStyle>
                               <DatePicker 
                                   placeholder='请选择日期' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, fy_date: value }))
                                   }}
                                   style={{ width: '100%' }}
                               />
                           </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='fy_amount' noStyle>
                               <InputNumber 
                                   placeholder='请输入金额' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, fy_amount: value }))
                                   }}
                                   style={{ width: '100%' }}
                                   min={0.01}
                               />
                           </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #3366cc'}}>
                           <ReportDeptSelect
                               yh_id={props.yh_id}
                               wrapperCol={{span:24}}
                               placeholder='请选择部门'
                               qy_id={props.qy_id}
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, fy_bm_id: e, fy_bm_name: f }))
                               }}
                               name="fy_bm_name"
                               defaultId={info.fy_bm_id}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                           />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 费用客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='fy_kh_id'
                                placeholder='请选择费用客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, fy_kh_id: value, fy_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={info.fy_uid}
                                yh_name={info.fy_uname}
                                defaultId={info.fy_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                        <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #3366cc'}}>
                            <ClientBankSelect
                               name='fy_khyhzh_name'
                               placeholder='请选择费用客户银行'
                               onChange={(value,label) => {
                                   setInfo(prevState => ({ ...prevState, fy_khyhzh_id: value, fy_khyhzh_name: label }))
                               }}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                               wrapperCol={{span:24}}
                               qy_id={props.qy_id}
                               yh_id={info.fy_uid}
                               defaultId={info.fy_khyhzh_id}
                               kh_id={info.fy_kh_id}
                           />
                        </Col>
                        {/* 第四行       */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 往来类型</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <ArapTypeSelect 
                                documentType='expense' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, fy_zflx: value }))
                                }}
                                name='fy_zflx'
                                required={true}
                                style={{marginBottom: 0}}
                                wrapperCol={{span:24}}
                            />
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>备注</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='fy_content' noStyle>
                               <OCRTextArea
                                   value={info.fy_content}
                                   onChange={(e) => {
                                       setInfo(prevState => ({ ...prevState, fy_content: e.target.value }))
                                   }}
                                   language="chi_sim"
                               />
                           </Form.Item>
                       </Col>
                       <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                       <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #3366cc'}}>
                            {info.fy_qyyhzh_date} <AccountCheck qyyhzh_id={info.fy_qyyhzh_id} name={info.fy_qyyhzh_name} />
                       </Col>                                   
                       {/* 第五行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}>编号/状态</Col>
                       
                       <Col span={6}  className={classes.col_middle_input}>    {props.fy_id}&emsp;<StateTag state={info.fy_state} />                        
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>附件</Col>
                       <Col span={14}  className={classes.col_bottom_input} style={{borderRight:'3px solid #3366cc'}}>
                           <UploadPic
                               name='fy_image_file'
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, fy_image_file: e, fy_image_name: f }))
                               }}
                               maxCount={5}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                               defaultFileList={defaultFileList}
                           />
                       </Col>        
                        {/* 第六行
                        <Col span={24} className={classes.bottom_row}>
                            <ExpenseNodeEdit 
                                qy_id={props.qy_id} 
                                user_id={props.yh_id} 
                                yh_name={props.yh_name} 
                                fy_id={props.fy_id} 
                                fy_state={props.fy_state}
                                fy_ctime={info.fy_ctime}
                                fy_uname={info.fy_uname}
                                fy_state_time={props.fy_state_time}
                            />
                        </Col> */}
                    </Row> 
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        if(info.fy_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }                                        
                                        if(info.fy_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.fy_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.fy_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }
                                        if(info.fy_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        updateSave({
                                            'fy_id': props.fy_id,
                                            'fy_price': info.fy_price,
                                            'fy_uid': props.yh_id,
                                            'fy_uname': props.yh_name,
                                            'fy_content': info.fy_content,
                                            'fy_bzd_id': info.fy_bzd_id,
                                            'fy_qy_id': qy_id,
                                            'fy_qy_name': qy_name,
                                            'fy_kh_id': info.fy_kh_id,
                                            'fy_kh_name': info.fy_kh_name,
                                            'fy_type_id': info.fy_type_id,
                                            'fy_type_name': info.fy_type_name,
                                            'fy_amount': info.fy_amount,
                                            'fy_bzd_xuhao': '',
                                            'fy_bzd_name': info.fy_bzd_name,
                                            'fy_date': info.fy_date,
                                            'fy_bzd_date_end': info.fy_bzd_date_end?info.fy_bzd_date_end:'',
                                            'fy_num': info.fy_num, 
                                            'fy_name': '',
                                            'fy_bzd_date': info.fy_bzd_date?info.fy_bzd_date:'',
                                            'fy_khyhzh_id': info.fy_khyhzh_id,
                                            'fy_khyhzh_name': info.fy_khyhzh_name,
                                            'fy_image_name': info.fy_image_name?info.fy_image_name:'',
                                            'fy_image_file': info.fy_image_file?info.fy_image_file:'',
                                            'fy_bm_id': info.fy_bm_id,
                                            'fy_bm_name': info.fy_bm_name,
                                            'fy_state': '1',
                                            'fy_zflx': info.fy_zflx,
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                                {/* {props.fy_state === '2' && <ExpenseWithdraw fy_id={props.fy_id} />} */}
                                {(props.fy_state === '1' || props.fy_state === '4') && <ExpenseDel fy_id={props.fy_id} />}
                                <Icon 
                                    type='submit' 
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                    
                                        if(props.fy_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }

                                        if(props.fy_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        }
                                        if(props.fy_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }

                                        if(props.fy_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(props.fy_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.fy_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        tijiao({
                                            'fy_id': props.fy_id,
                                            'fy_uid': props.yh_id,  
                                            'fy_uname': props.yh_name,
                                            'qy_id': qy_id,
                                            'qy_name': qy_name,
                                            'fy_name': '无',
                                            'fy_date': info.fy_date,
                                            'fy_kh_id': info.fy_kh_id, 
                                            'fy_kh_name': info.fy_kh_name,
                                            'fy_sp_fy_amount': info.fy_amount,
                                            'fy_sp_fy_content': info.fy_content,
                                            'fy_sp_dsbzd_id': info.fy_bzd_id,
                                            'fy_sp_dsbzd_name': info.fy_bzd_name,
                                            'fy_bm_id': info.fy_bm_id,
                                            'fy_bm_name': info.fy_bm_name,
                                            'fy_khyhzh_id': info.fy_khyhzh_id,
                                            'fy_khyhzh_name': info.fy_khyhzh_name,
                                            'fy_image_name': info.fy_image_name?info.fy_image_name:'',
                                            'fy_image_file': info.fy_image_file?info.fy_image_file:'',
                                            'fy_zflx': info.fy_zflx,
                                            'fy_spjd_bm_id': info.fy_bm_id,
                                            'fy_spjd_zflx': info.fy_zflx,
                                            'fy_spjd_amount': info.fy_amount,
                                            'fy_spjd_user_id': props.yh_id,
                                        }).then(res => {
                                            if(res.data.Status === 'success') {
                                                message.success('费用单提交成功！')
                                            } else {
                                                message.error('费用单提交失败！'+res.data.Message)
                                            }
                                        })
                                        .catch((err) => {
                                            message.error('费用单提交失败！'+(err.response?.data?.Message||''))
                                        })
                                        .finally(() => {
                                            setIsSubmitting(false);
                                        })
                                    }} 
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                />  
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default ExpenseEdit